import {
  getImportTitle,
  isInvoiceImportNotification
} from 'common/header/notifications/hooks/mappers/impl/importMapper';
import { getNotificationState } from 'common/header/notifications/hooks/mappers/impl/shared';
import { type MappedNotification, type NotificationMapper } from 'common/header/notifications/Notifications.types';

export const importUserMapper: NotificationMapper = (notification, options) => {
  const { isReady, isError } = getNotificationState(notification.status);
  return {
    ...notification,
    title: getImportTitle(notification, options).title,
    to: isReady || isError ? importUrl(notification, options.tenantCode) : undefined
  };
};

function importUrl(notification: MappedNotification, tenantCode: string) {
  return isInvoiceImportNotification(notification)
    ? `/${tenantCode}/settings/monitoring/invoiceimports`
    : userActivityUrl(notification, tenantCode);
}

function userActivityUrl(notification: MappedNotification, tenantCode: string) {
  return notification.resourceUid ? `/${tenantCode}/workers?userActivityUid=${notification.resourceUid}` : undefined;
}
